export const create = (size: number) => [...Array(size)];

export const swapLocations = <T>(array: T[], from: number, to: number) => {
  const items = Array.from(array);
  const temp = items[to];
  items[to] = items[from];
  items[from] = temp;
  return items;
};
